<template>
  <div class="vehicle-schedule-main">
    <div class="gantt-container" :style="{ maxWidth: 'calc(100%)' }">
      <div class="date-container">
        <div class="date-title">Show timeline</div>
        <DateTimePicker placeholder="from" :value.sync="startDate" />
        <DateTimePicker placeholder="to" :value.sync="endDate" />
        <div class="refresh-container">
          <button @click="showRefreshDropdown = !showRefreshDropdown">{{ refreshText }}</button>
          <div v-if="showRefreshDropdown" class="refresh-dropdown">
            <div>Refresh Every:</div>
            <button @click="refreshIntervalClicked($event, 10)">10 seconds</button>
            <button @click="refreshIntervalClicked($event, 30)">30 seconds</button>
            <button @click="refreshIntervalClicked($event, 300)">5 minutes</button>
            <button @click="refreshIntervalClicked($event, 600)">10 minutes</button>
            <button @click="refreshIntervalClicked($event, 1800)">30 minutes</button>
            <button @click="refreshIntervalClicked($event, 3600)">1 hour</button>
            <button class="refresh-now" @click="refreshIntervalClicked($event, null)">Refresh Now</button>
            <button v-if="refreshInterval" class="cancel-refresh" @click="refreshIntervalClicked(null, null)">Cancel Refresh</button>
          </div>
        </div>
        <div class="last-refresh">Last Refreshed : {{ lastRefresh }}</div>
      </div>
      <div class="gantt-with-legends">
        <GanttChartV3 :items="ganttItems" @taskClicked="ganttTaskClicked" />
        <div class="gantt-legends">
          <div class="gantt-legends-items" v-for="(l, i) in legendsItems" :key="i">
            <div class="gantt-legends-color" :style="{ backgroundColor: l['ColorHexa'] }"></div>
            <div>{{ l['ColorDesc'] }}</div>
          </div>
        </div>
      </div>
      <Loader class="gantt-loader" :loadingText="loadText" :isVisible.sync="loading"/>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      loading: false,
      loadText: 'Loading',

      startDate: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 00:00`),
      endDate: new Date(`${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()} 23:59`),

      ganttItems: [],
      legendsItems: [],

      showRefreshDropdown: false,
      refreshTime: 0,
      refreshTimeStart: 0,
      refreshInterval: null,

      lastRefresh: '',
    }
  },
  props: {
  },
  computed: {
    refreshText: function() {
      if (!this.refreshInterval) { return 'Refresh' }
      else {
        let totalSeconds = this.refreshTime;
        let inMinute = Math.floor(totalSeconds / 60);

        if (totalSeconds >= 60) {
          return `Refresh in ${inMinute} minute${inMinute > 1 ? 's' : ''}`;
        } else {
          return `Refresh in ${this.refreshTime} seconds`;
        }
      }
    }
  },
  methods: {
    getGanttDetails: async function() {
      this.loading = true;
      this.loadText = 'Getting Details';

      this.ganttItems = [];
      this.ganttItems = await this.$apiCallV2(`/TruckingSchedule/GanttViewTASV2?start=${this.$dateTime.getDateTime(this.startDate, 'yyyy-MM-dd HH:mm')}&end=${this.$dateTime.getDateTime(this.endDate, 'yyyy-MM-dd HH:mm')}&viewType=TEAM_TR`);
      
      this.lastRefresh = this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd HH:mm');

      this.loading = false;

      if (this.refreshTimeStart > 0) {
        this.refreshIntervalClicked(null, this.refreshTimeStart);
      }
    },
    ganttTaskClicked: function(e) {
      console.log('from vspage', e);
    },
    refreshCountdown: function() {
      this.refreshTime--;
      if (this.refreshTime < 0) {
        this.refreshTime = this.refreshTimeStart;
      } else if (this.refreshTime == 0) {
        this.getGanttDetails();
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    },
    refreshIntervalClicked: function(e, seconds) {
      if (seconds) {
        this.refreshTime = seconds;
        if (e) { this.refreshTimeStart = seconds };
        if (this.refreshInterval) {
          clearInterval(this.refreshInterval);
        }

        this.refreshInterval = setInterval(this.refreshCountdown, 1000);
      } else {
        if (e) {
          this.getGanttDetails();
        } else {
          clearInterval(this.refreshInterval);
          this.refreshInterval = null;
          this.refreshTimeStart = 0;
        }
      }

      this.showRefreshDropdown = false;
    },
  },
  async mounted() {
    await this.getGanttDetails();
    
    this.loading = true;
    this.loadText = 'Getting Legends';
    this.legendsItems = await this.$apiCallV2('/TruckingSchedule/GetLegends?viewType=TEAM_TR');

    this.loading = false;
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.vehicle-schedule-main {
  width: 100%;
  padding: 10px 5px 10px 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;

  > .gantt-container {
    background-color: white;
    padding: 5px;
    border-radius: 5px;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    transition: 0.3s;
    position: relative;

    > .date-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 5px 0;

      > * {
        margin-left: 5px;
      }

      > .date-title {
        height: 100%;
        position: relative;
        top: 3px;
      }

      > .refresh-container {
        position: relative;
        min-width: 200px;

        > button {
          width: 100%;
        }

        > .refresh-dropdown {
          position: absolute;
          top: 100%;
          background-color: white;
          width: 100%;
          z-index: 10;
          padding: 5px;
          border-width: 1px;
          border-style: solid;
          border-color: transparent black black black;

          > button {
            width: 100%;
            border-radius: 0;
            padding: 3px;
          }

          > .refresh-now {
            margin: 5px 0;
          }

          > .cancel-refresh {
            background-color: red;
            color: white;
          }
        }
      }

      > .last-refresh {
        margin: 0 5px;
      }
    }

    > .gantt-with-legends {
      height: calc(100% - 40px);
      display: flex;

      > .gantt-legends {
        min-width: 100px;
        max-width: 100px;
        height: fit-content;
        font-size: 10px;
        margin-left: 5px;

        > .gantt-legends-items {
          display: flex;
          align-items: center;
          margin-bottom: 5px;

          > .gantt-legends-color {
            max-width: 20px;
            min-width: 20px;
            max-height: 20px;
            min-height: 20px;
            margin-right: 3px;
          }
        }
      }
    }

    > .gantt-loader {
      position: absolute;
      left: 0;
      top: 0 !important;
      height: 100% !important;
      width: 100%;
    }
  }

}
</style>